export var DraggableComponentTypes;
(function (DraggableComponentTypes) {
    DraggableComponentTypes["Text"] = "text";
    DraggableComponentTypes["Title"] = "title";
    DraggableComponentTypes["Div"] = "div";
    DraggableComponentTypes["Grid"] = "grid";
    DraggableComponentTypes["GridItem"] = "gridItem";
    DraggableComponentTypes["Container"] = "container";
    DraggableComponentTypes["Image"] = "image";
    DraggableComponentTypes["Link"] = "link";
    DraggableComponentTypes["Button"] = "button";
    DraggableComponentTypes["Form"] = "form";
    DraggableComponentTypes["Svg"] = "svg";
    DraggableComponentTypes["List"] = "list";
    DraggableComponentTypes["ListItem"] = "listItem";
    DraggableComponentTypes["Icon"] = "icon";
    DraggableComponentTypes["Navbar"] = "navbar";
    DraggableComponentTypes["NavbarVertical"] = "navbarVertical";
    DraggableComponentTypes["Html"] = "html";
    DraggableComponentTypes["ImageSlider"] = "imageSlider";
    DraggableComponentTypes["RepeatableSlider"] = "repeatableSlider";
    DraggableComponentTypes["RepeatableGrid"] = "repeatableGrid";
    DraggableComponentTypes["Accordion"] = "accordion";
})(DraggableComponentTypes || (DraggableComponentTypes = {}));
//# sourceMappingURL=draggable.js.map